import React, { useEffect, useRef, useState } from 'react';
import { IntroductionAdminSelector } from './components/IntroductionAdminSelector';
import { IntroductionAdminSearch } from './components/IntroductionAdminSearch';
import { IntroductionAdminGrid } from './components/IntroductionAdminGrid';
import { IntroductionAdminColumns } from './consts/IntroductionAdminColumns';
import Pagination from '../components/Pagination';
import { defaultProfileImage } from '../../utils/constants';
import { IntroductionAdminDetails } from './components/IntroductionAdminDetails';
import { useLayout } from '../../../_metronic/layout/core';
import { getIntroductions } from '../../services/introductionService';
import { IntroductionListResponse } from './models';


const _mock = [
    {
        id: 1,
        authorAvatar: defaultProfileImage,
        authorName: 'Jack',
        created_at: "2026-06-17T10:02:29.051729+03:00",
        sent: 'W'
    }
];


const IntroductionAdminListPage: React.FC = () => {
    const { config, setLayout } = useLayout()
    const restoreRef = useRef(config)
    const [paginationData, setPaginationData] = useState<any>(null);
    const [section, setSection] = useState<string>('all');
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState<IntroductionListResponse>([]);
    const [detail, setDetail] = useState<any | null>(null);
    const limit = 10;

    useEffect(() => {
        restoreRef.current = config
        setLayout({
            ...config,
            header: { ...config.header, display: true },
            aside: { ...config.aside, display: true },
            toolbar: { ...config.toolbar, display: false },
            footer: { ...config.footer, display: true },
        })
        return () => setLayout(restoreRef.current)
    }, []);

    useEffect(() => {
        getList();
    }, [section,search]);

    const totalPages = paginationData
        ? Math.ceil(paginationData.count / limit)
        : 1;

    const getList = async (page:number=1,offset:number=0) => {
        setLoading(true);
        const introductions_ = await getIntroductions({ section: section, limit, offset, search: search })
        setPaginationData(introductions_);
        setData(introductions_?.results || []);
        setCurrentPage(page);
        setLoading(false);
    }

    const handlePageChange = async (page: number) => {
        const offset = (page - 1) * limit;
        await getList(page,offset);
    };

    const handleOnCompleteActions = () => {
        setDetail(null);
        getList();
    }

    return (
        <>
            {!!detail && 
                <IntroductionAdminDetails id={detail}
                    onClose={() => setDetail(null)}
                    onComplete={handleOnCompleteActions}
                />
            }
            <div className='introduction-admin-container'>
                <div className='w-100 d-flex flex-row justify-content-between align-items-center'>
                    <h1>Introductions</h1>
                </div>

                <IntroductionAdminSelector 
                    section={section}
                    onChange={setSection}
                />

                <div className="introduction-admin-table-wrapper">
                    <IntroductionAdminSearch 
                        value={search}
                        onChange={setSearch}
                    />

                    <IntroductionAdminGrid 
                        columns={IntroductionAdminColumns}
                        loading={loading}
                        data={data}
                        onSelect={(u) => setDetail(u.id)}
                    />
                    {!loading && data.length === 0 ? (
                        <span className="text-center">There is nothing to show for now.</span>
                    ): (
                        <div className="text-end">
                            <Pagination
                                currentPage={currentPage} 
                                totalPages={totalPages} 
                                onPageChange={handlePageChange} 
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default IntroductionAdminListPage;